module.exports = __webpack_public_path__ + "img/ramos_fizz.ea88fe8a.jpg";